import { useEffect } from 'react';
import { useCollaborationContext } from '@/providers/CollaborationProvider';

export function useCollaboration(projectId: string | undefined) {
  const ctx = useCollaborationContext();

  useEffect(() => {
    if (projectId) {
      ctx.joinRoom(projectId);
      return () => ctx.leaveRoom(projectId);
    }
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  return ctx;
}
